module.exports = __webpack_public_path__ + "img/max_box_red_outline.7e0f22e1.png";